module.exports = __webpack_public_path__ + "static/media/live_cam.1979d709.png";